import { Routes, Route } from "react-router-dom";
import React from "react";
import { Home } from "./Home";
import { Login } from "./Login";
import { Register } from "./Register";
import { AuthProvider } from "./context/authContext";
import { ProtectedRoute} from "./ProtectedRoute";
import Cierre from "./Cierre";
import Cierre2 from "./Cierre2";


function App() {
  return (
    <div>
      <AuthProvider>
        <Routes>
          <Route path="/" element={
          <ProtectedRoute><Home/></ProtectedRoute>
          
          } />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/cierre" element={<Cierre />} />
          <Route path="/error" element={<Cierre2 />} />
        </Routes>
      </AuthProvider>
    </div>
  );
}

export default App;
